import { render, staticRenderFns } from "./ExpenseUpdateForm.vue?vue&type=template&id=4beb80cf"
import script from "./ExpenseUpdateForm.vue?vue&type=script&lang=js"
export * from "./ExpenseUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports